import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useContext } from 'react';
import { AuthContext } from "../AuthContext";
import { useCreateUserMutation } from "./useCreateUserMutation";
import { useLoginUserMutation } from "./useLoginUserMutation";
export var useAuth = function useAuth() {
  var context = useContext(AuthContext);
  var _useLoginUserMutation = useLoginUserMutation(),
    _useLoginUserMutation2 = _slicedToArray(_useLoginUserMutation, 1),
    loginUser = _useLoginUserMutation2[0];
  var _useCreateUserMutatio = useCreateUserMutation(),
    _useCreateUserMutatio2 = _slicedToArray(_useCreateUserMutatio, 1),
    registerUser = _useCreateUserMutatio2[0];
  var login = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variables) {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loginUser({
              variables: variables
            });
          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [loginUser]);
  var register = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variables) {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return registerUser({
              variables: variables
            });
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [registerUser]);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return _objectSpread(_objectSpread({}, context), {}, {
    login: login,
    register: register
  });
};
export default useAuth;